// Funktion zur Anpassung der Höhen pro Grid-Reihe
function adjustGridRowHeights() {
  const grid = document.querySelector('.post-grid');
  if (!grid) return;

  // Alle Grid-Elemente zurücksetzen
  const elements = Array.from(grid.querySelectorAll('.grid-element'));
  elements.forEach(el => {
    el.style.height = 'auto';
    el.querySelector('.post-image')?.style.height = 'auto';
  });

  // Warten bis Bilder geladen sind
  Promise.all(
    Array.from(grid.querySelectorAll('img')).map(img => {
      if (img.complete) return Promise.resolve();
      return new Promise(resolve => {
        img.addEventListener('load', resolve);
        img.addEventListener('error', resolve);
      });
    })
  ).then(() => {
    // Aktuelle Anzahl der Spalten ermitteln
    const gridStyle = window.getComputedStyle(grid);
    const templateColumns = gridStyle.gridTemplateColumns.split(' ');
    const columns = templateColumns.length;

    if (columns === 0) return;

    // Elemente in Reihen gruppieren und Höhen anpassen
    const rows = [];
    for (let i = 0; i < elements.length; i += columns) {
      const row = elements.slice(i, i + columns);
      if (row.length > 0) {
        // Höhen für Bilder in dieser Reihe anpassen
        const maxImageHeight = Math.max(...row.map(el => 
          el.querySelector('.image')?.getBoundingClientRect().height || 0
        ));
        row.forEach(el => {
          const postImage = el.querySelector('.post-image');
          if (postImage) postImage.style.height = maxImageHeight + 'px';
        });

        // Gesamthöhe der Grid-Elemente in dieser Reihe anpassen
        const maxHeight = Math.max(...row.map(el => el.getBoundingClientRect().height));
        row.forEach(el => el.style.height = maxHeight + 'px');
      }
    }
  });
}

// Debounce-Funktion für resize
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Event-Listener für Resize (mit Debounce) und Initial-Load
const debouncedAdjust = debounce(adjustGridRowHeights, 250);
window.addEventListener('load', adjustGridRowHeights);
window.addEventListener('resize', debouncedAdjust);

// Für dynamisch nachgeladene Inhalte
const observer = new MutationObserver(adjustGridRowHeights);
const grid = document.querySelector('.post-grid');
if (grid) {
  observer.observe(grid, { 
    childList: true, 
    subtree: true 
  });
} 